export var imageRenditions = {
  desktopL: {
    w: '620',
    h: '806'
  },
  desktop: {
    w: '561',
    h: '718'
  },
  tabletL: {
    w: '561',
    h: '718'
  },
  tabletP: {
    w: '640',
    h: '817'
  },
  mobile: {
    w: '375',
    h: '485'
  }
};